import React from "react";

import Rows from "./Rows";
import { v4 as uuidv4 } from "uuid";

class CreateRows extends React.Component {
  state = {
    data: [this.create()],
  };

  create() {
    const { columns } = this.props;
    const create = { id: uuidv4() };

    Object.keys(columns).forEach((key) => {
      if (key !== "id") {
        create[key] = null;
      }
    });

    return create;
  }

  async onAdd(row) {
    const onAdd = this.props.onAdd || null;

    if (onAdd) {
      const result = await onAdd(row);
      if (!result) {
        return;
      }
    }

    const data = this.state.data.reduce(
      (agg, item) => (item.id === row.id ? agg : [...agg, item]),
      []
    );

    if (data.length === 0) {
      data.push(this.create());
    }

    this.setState({
      ...this.state,
      data,
    });
  }

  onClear(row) {
    let { data } = this.state;
    data = data.map((item) => (item.id === row.id ? this.create() : item));
    this.setState({
      ...this.state,
      data,
    });
  }

  onInsert(row) {
    let { data } = this.state;
    data.push(this.create());
    this.setState({
      ...this.state,
      data,
    });
  }

  onRemove(row) {
    let { data } = this.state;

    data = data.reduce(
      (agg, item) => (item.id === row.id ? agg : [...agg, item]),
      []
    );

    this.setState({
      ...this.state,
      data,
    });
  }

  // onCreateChange(key, value, row) {
  //   let { create } = this.state;

  //   create = create.map((item) =>
  //     item.id === row.id ? { ...item, [key]: value } : item
  //   );

  //   this.setState({ ...this.state, create });
  // }

  // onCreateCancel(row) {
  //   const create = this.state.create.map((item) =>
  //     item.id === row.id ? this.create() : item
  //   );

  //   this.setState({
  //     ...this.state,
  //     create,
  //   });
  // }

  // onCreateRow() {
  //   if (this.hasCreate()) {
  //     this.setState({
  //       ...this.state,
  //       create: [...this.state.create, this.create()],
  //     });
  //   }
  // }

  // onRemoveCreateRow(row) {
  //   if (this.hasCreate()) {
  //     let { create } = this.state;

  //     create = create.reduce(
  //       (agg, item) => (item.id === row.id ? agg : [...agg, item]),
  //       []
  //     );

  //     this.setState({
  //       ...this.state,
  //       create,
  //     });
  //   }
  // }

  render() {
    const { data } = this.state;
    const { hasAdd } = this.props;

    if (!hasAdd) {
      return null;
    }

    return (
      <Rows
        {...this.props}
        data={data}
        isCreating={true}
        isEditing={true}
        onEdit={(row) => this.onAdd(row)}
        onCancel={(row) => this.onClear(row)}
        onRemove={(row) => this.onRemove(row)}
        onInsert={(row) => this.onInsert(row)}
      />
    );
  }
}

export default CreateRows;
